<template>
  <el-row class="_login-app">
    <el-col :span="$store.state.isMB?24:12" :offset="$store.state.isMB?0:9">
      <div class="out-box">
        <div class="login-box">
          <div class="title">用户登录</div>
          <template>
            <el-form
              ref="form"
              size="large"
              :model="data"
              :rules="rules"
              @keyup.enter.native="login"
            >
              <el-form-item prop="LoginId">
                <el-input
                  v-model="data.LoginId"
                  class="boxInp"
                  prefix-icon="el-icon-user"
                  placeholder="登录账号"
                />
              </el-form-item>
              <el-form-item prop="Pwd">
                <el-input
                  show-password
                  type="password"
                  class="boxInp"
                  prefix-icon="el-icon-lock"
                  v-model="data.Pwd"
                  placeholder="登录密码"
                />
              </el-form-item>
              <el-row>
                <el-col :span="isMB?13:16" style="padding-right:10px;">
                  <el-form-item prop="VerCode">
                    <el-input
                      prefix-icon="el-icon-key"
                      v-model="data.VerCode"
                      placeholder="填写验证码"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="isMB?11:8">
                  <s-identify :identifyCode="identifyCode" @refresh="refreshCode"></s-identify>
                </el-col>
              </el-row>
              <el-button
                size="large"
                :loading="loading"
                type="primary"
                style="width:100%;border: none; background:#b97246;"
                @click="login"
              >登录</el-button>
            </el-form>
          </template>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import sIdentify from "@/components/common/sIdentify";

export default {
  components: {
    sIdentify,
  },
  data() {
    const validateCode = (rule, value, callback) => {
      if (this.identifyCode !== value) {
        this.data.VerCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      api: require("@/api/sy/user").default,
      Base64: require("js-base64").Base64,
      identifyCode: "",
      loading: false,
      data: {
        LoginId: "",
        Pwd: "",
        Code: "",
        VerCode: "",
      },
      time: 0,
      interval: null,
      isMB: this.$store.state.isMB,
      rules: {
        LoginId: [{ required: true, message: "请输入登录账号" }],
        Pwd: [{ required: true, message: "请输入登录密码" }],
        // Code: [{ required: true, message: "请输入短信验证码" }],
        VerCode: [
          { required: true, message: "请输入验证码" },
          { validator: validateCode, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    let token = this.$commonJs.getCookie("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
          if (loginInfo) {
            if (loginInfo.ChangePwd == true) {
              this.$router.push("/password").catch((err) => {});
            } else {
              this.$router.push("/workbench").catch((err) => {});
            }
          }
        }
      });
    }
  },
  methods: {
    login() {
      this.$refs.form
        .validate()
        .then((res) => {
          if (!res) return false;
          this.loading = true;
          this.$store
            .dispatch("loginByMobile", this.data)
            .then((res) => {
              if (res.Data.ChangePwd == true) {
                this.$store.dispatch("changeSetting", {
                  key: "fixedHeader",
                  value: false,
                });
                this.$router.push("/password").catch((err) => {});
              } else {
                this.$router.push("/workbench").catch((err) => {});
              }
            })
            .catch((res) => {
              this.$message.error(res.Msg);
              this.loading = false;
              this.data.VerCode = "";
              this.refreshCode();
              console.log(res);
            });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    refreshCode() {
      this.identifyCode = "";
      this.api.getVerCode().then((res) => {
        this.identifyCode = this.Base64.decode(res);
        console.log(this.identifyCode);
      });
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },
};
</script>
<style lang="scss">
._login-app {
  @media screen and (min-width: 768px) {
    min-width: 1200px;
    min-height: 620px;
  }
  .out-box {
    display:flex;
    flex-direction:column;
    justify-content:center;
    height:100vh;
    @media screen and (min-width: 768px) {
      min-height: 620px;
    }
  }
  .login_title {
    color: #fff;
    text-align: center;
    margin-bottom: 15vh;
    width: 100%;
    font-size: 44px;
    letter-spacing: 16px;
    @media screen and (max-width: 767px) {
      padding: 0 15%;
      font-size: 28px;
      margin-bottom: 10vh;
      letter-spacing: 2px;
    }
    @media screen and (min-width: 768px) and (max-width: 1600px) {
      margin-bottom: 13vh;
    }
  }
  @media screen and (max-width: 767px) {
    background-image: url("../assets/bgPic_MB.jpg");
    background-size: 100% 100%;
  }
  @media screen and (min-width: 768px) {
    background-image: url("../assets/bgPic.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }
  .login-box {
    z-index: 1000;
    border-radius: 12px;
    width: 27vw;
    max-width: 350px;
    margin: 0px auto;
    padding: 5px 25px 25px;
    @media screen and (min-width: 768px) {
      min-width: 330px;
    }
    @media screen and (max-width: 767px) {
      width: 80%;
      margin-top: -5%;
      padding: 20px 25px 20px;
      background: #fff;
    }
    .title {
      height: 40px;
      font-weight: bold;
      font-family: "宋体";
      font-size: 22px;
      text-align: center;
      color: #b97246 ;
      letter-spacing: 1px;
      @media screen and (max-width: 767px) {
        font-size: 18px;
      }
    }

    .forget-pwd {
      font-size: 16px;
      margin-top: 5px;
      display: inline-block;
      color: gray;
      cursor: pointer;
    }
    .el-input__inner {
      border-radius: 4px;
    }
    // .el-form-item__error {
    //   color: #fff !important;
    // }
  }
  .boxInp {
    .el-input__inner:focus {
      border-color: #eee;
    }
  }
}
</style>